import { Col, Image, Row } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { FillModal, UserInfo } from "../../components";
import CsFloatButton from "../../components/CsFloatButton";
import { useAuth } from "../../context/AuthContext";
import { useLoading } from "../../context/LoadingContext";
import { useMobile } from "../../context/MobileContext";
import { useModal } from "../../context/ModalContext";
import localStorageKey from "../../enumerations/localStorageKey";
import { useGetCs, useGetUser } from "../../hooks/user/user.hook";
import { handleClickApp } from "../../plugins/utils";
import "./style.scss";

const UserMenu = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { setMainLoading } = useLoading();
  const { setToken } = useAuth();
  const { openTipsModal } = useModal();
  const { isMobile } = useMobile();
  const [openModal, setOpenModal] = useState(false);
  const [modalData, setModalData] = useState({});

  const { data: userInfo, isFetching: isFetchingUserInfo } = useGetUser();
  const { data: cs, isFetching: isFetchingCs } = useGetCs();

  const handleClickLogOut = () => {
    setToken(null);
    localStorage.removeItem(localStorageKey.TOKEN);
    navigate("/");
  };

  const menuEnum = [
    {
      src: `/images/user/recharge.png`,
      name: "recharge",
      text: t("normal.recharge"),
      path: "/user/recharge/recharge?tab=recharge&radioValue=recharge",
      hide: false,
    },
    {
      src: `/images/user/withdraw.png`,
      name: "withdraw",
      text: t("normal.withdraw"),
      path: "/user/withdraw/withdraw?tab=withdraw&radioValue=withdraw",
      hide: false,
    },
    // {
    //   src: `/images/user/bank-info.png`,
    //   name: "bankInfo",
    //   text: t("user.bankInfo"),
    //   path: "/user/withdrawAddress?tab=withdrawAddress",
    // hide: false,
    // },
    {
      src: `/images/user/bank-info.png`,
      name: "withdrawAddress",
      text: t("user.withdrawAddress"),
      path: "/user/withdrawAddress?tab=withdrawAddress",
      hide: false,
    },
    {
      src: `/images/user/gift.png`,
      name: "gift",
      text: t("normal.gift"),
      path: "/user/gift?tab=gift",
      hide: false,
    },
    {
      src: `/images/user/my-income.png`,
      name: "myIncome",
      text: t("user.myIncome"),
      path: "/user/my-income?tab=my-income",
      hide: false,
    },
    {
      src: `/images/user/my-team.png`,
      name: "my-team",
      text: t("user.myTeam"),
      path: "/user/my-team?tab=my-team",
      hide: false,
    },
    {
      src: `/images/user/my-project.png`,
      name: "myProject",
      text: t("normal.myProject"),
      path: "/user/my-project?tab=my-project",
      hide: false,
    },
    {
      src: `/images/user/safe.png`,
      name: "safe",
      text: t("user.safe"),
      path: "/user/safe?tab=safe",
      hide: false,
    },
    {
      src: `/images/user/download.png`,
      name: "app",
      text: t("nav.app"),
      path: null,
      hide: false,
      onClick: () => handleClickApp("navigate"),
    },
    {
      src: `/images/user/tg.png`,
      name: "tg",
      text: t("user.tg"),
      path: userInfo?.zhanshi,
      hide: !userInfo?.zhanshi,
    },
    {
      src: `/images/user/blog.png`,
      name: "blog",
      text: t("normal.blog"),
      path: "/blog",
      hide: false,
    },
    {
      src: `/images/user/about.png`,
      name: "about",
      text: t("normal.about"),
      path: "/about",
      hide: false,
    },
    {
      src: `/images/user/tutorial.png`,
      name: "tutorial",
      text: t("normal.tutorial"),
      path: "/tutorial",
      hide: false,
    },
    {
      src: `/images/user/sign-out.png`,
      name: "signOut",
      text: t("user.signOut"),
      path: null,
      hide: false,
      onClick: handleClickLogOut,
    },
  ];

  useEffect(() => {
    setMainLoading(isFetchingUserInfo || isFetchingCs);
  }, [isFetchingUserInfo, isFetchingCs]);

  return (
    <div className="user-menu">
      <UserInfo userInfo={userInfo} />
      <div className="menu">
        <Row gutter={[6, 20]}>
          {menuEnum.map((item, index) => {
            if (item.hide) return null;
            return (
              <Col key={index} className="gutter-row" span={6}>
                <div
                  className="item"
                  onClick={item.onClick ? item.onClick : () => (window.location.href = item.path)}
                >
                  <Image src={item.src} alt={item.name} preview={false} className="img" />
                  <div className="text">{item.text}</div>
                </div>
              </Col>
            );
          })}
        </Row>
      </div>
      <FillModal open={openModal} setOpen={setOpenModal} data={modalData} />
      {isMobile && (
        <CsFloatButton
          setOpenModal={setOpenModal}
          setModalData={setModalData}
          userInfo={userInfo}
          cs={cs}
        />
      )}
    </div>
  );
};

export default UserMenu;
